import React, { useEffect, useState } from "react";
import { CheckSquare, Square } from "lucide-react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import { toast } from "react-toastify";

const CrmPlaybookPanel = ({ leadId, compact = false }) => {
  const [playbook, setPlaybook] = useState([]);
  const [done, setDone] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  useEffect(() => {
    if (!leadId) return;
    let cancelled = false;
    setLoading(true);
    fetch(`${url}/leads/intelligence/${leadId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((res) => {
        if (cancelled || !res) return;
        setPlaybook(res.playbook || []);
        setDone(res.playbookProgress || []);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [leadId, url, token]);

  const toggleStep = async (stepId) => {
    if (!leadId || saving) return;
    const isDone = done.includes(stepId);
    setSaving(true);
    try {
      const res = await fetch(`${url}/leads/playbook-progress/${leadId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ stepId, done: !isDone }),
      });
      if (!res.ok) throw new Error("Save failed");
      const data = await res.json();
      setDone(data.playbookProgress || []);
    } catch {
      toast.error("Could not update checklist");
    } finally {
      setSaving(false);
    }
  };

  if (!leadId || loading) return null;
  if (!playbook.length) return null;

  const completed = done.filter((id) => playbook.some((s) => s.id === id)).length;

  return (
    <div className={`crm-playbook${compact ? " crm-playbook--compact" : ""}`}>
      <div className="crm-playbook__head">
        <strong>Stage playbook</strong>
        <span className="crm-insights__muted">
          {completed}/{playbook.length}
        </span>
      </div>
      <ul className="crm-playbook__list">
        {playbook.map((step) => {
          const checked = done.includes(step.id);
          return (
            <li key={step.id}>
              <button
                type="button"
                className={`crm-playbook__step${checked ? " is-done" : ""}`}
                onClick={() => toggleStep(step.id)}
                disabled={saving}
              >
                {checked ? <CheckSquare size={16} /> : <Square size={16} />}
                <span>{step.label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CrmPlaybookPanel;
